import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const releaseConversationClaim = {
  name: "releaseConversationClaim" as const,
  input: z.object({ conversationId: zExt.objectId() }),
  output: z.object({ released: z.boolean() }),
};
